import { useCallback, useEffect, useState } from "react";
import { Button, Radio, Row, Select, Upload, Input, Form } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { EstagioService } from "../../../../services/estagio.service";
import { toast } from "react-toastify";
// import getAPPS from "../../../../utils/getAppAndGroups";

export function Sistema({ updateFile, form }) {
  function getBase64(img, callback) {
    const reader = new FileReader();
    reader.addEventListener("load", () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const beforeUpload = useCallback(
    (file, name) => {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        toast.error("Arquivo precisa ser menor que 2MB!");
        return false;
      }
      getBase64(file, (imageUrl) => updateFile({ [name]: imageUrl }));
      return false;
    },
    [updateFile]
  );

  const props = {
    accept: "image/png, image/jpeg, application/pdf",
    maxCount: 1,
    multiple: false,
  };

  // const info = useCallback((texto, nivelAcesso) => {
  //   Modal.info({
  //     title: nivelAcesso,
  //     content: (
  //       <div>
  //         <p>{texto}</p>
  //       </div>
  //     ),
  //     onOk() {},
  //   });
  // }, []);

  const { Option } = Select;

  function onChange(value) {
    // console.log(`selected ${value}`);
  }

  function onBlur() {
    // console.log("blur");
  }

  function onFocus() {
    // console.log("focus");
  }

  function onSearch(val) {
    // console.log("search:", val);
  }

  /* chamar api intituiçoes */

  const [instituicoes, setInstituicoes] = useState({});
  useEffect(() => {
    EstagioService.allInstituicoes()
      .then((responde) => {
        setInstituicoes(responde.data);
      })
      .catch(() => {
        console.log(`"erro"`);
      });
  }, []);

  /* chamar api allCursos */
  const [cursos, setCursos] = useState([]);
  useEffect(() => {
    EstagioService.getAllCursos()
      .then((response) => {
        // console.log("data" + JSON.stringify(response.data))
        setCursos(response.data);
      })
      .catch(() => {});
  }, []);

  const [value, setValue] = useState("MANHA");
  const onChage = (e) => {
    // console.log("raio check", e.target.value);
    setValue(e.target.value);
  };

  const [disponivel, setDisponivel] = useState(2);
  const onChageDisponivel = (e) => {
    // console.log("aquieee", e.target.value);
    setDisponivel(e.target.value);
  };

  const [deficiencia, setDeficiencial] = useState(2);
  const onChageDeficiencia = (e) => {
    // console.log("aquieee", e.target.value);
    setDeficiencial(e.target.value);
  };

  return (
    <>
      <Row justify="center" align="middle">
        <div className="ant-descriptions-title">Dados de Ensino</div>
      </Row>

      <Form.Item
        className="inputStyle"
        name="instituicao"
        label="Instituição de Ensino"
        rules={[
          {
            required: true,
            message: "Por favor informe a Instituição ensino!",
          },
        ]}
      >
        <Select
          placeholder="Instituição ensino"
          optionFilterProp="children"
          onChange={onChange}
          onFocus={onFocus}
          onBlur={onBlur}
          onSearch={onSearch}
          filterOption={(input, option) =>
            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
          }
        >
          {Object.entries(instituicoes).map((instituicoe, key) => {
            return (
              <Option key={key} value={instituicoe[0]}>
                {instituicoe[1]}
              </Option>
            );
          })}
        </Select>
      </Form.Item>

      <div className="duasCollumn">
        <Form.Item
          className="inputStyle"
          name="curso"
          label="Curso"
          rules={[
            {
              required: true,
              message: "Por favor informe o curso!",
            },
          ]}
        >
          <Select
            placeholder="Selecione o curso  "
            rules={[
              {
                required: true,
                message: "Por favor, informe o Turno",
              },
            ]}
            optionFilterProp="children"
            onChange={onChange}
            onFocus={onFocus}
            onBlur={onBlur}
            onSearch={onSearch}
            filterOption={(input, option) =>
              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {Object.entries(cursos).map((curso, key) => {
              return (
                <Option key={key} value={curso[0]}>
                  {curso[1]}
                </Option>
              );
            })}
          </Select>
        </Form.Item>
        <div className="sizeBoxWidth" />
        <Form.Item
          className="inputStyle"
          name="semestre"
          label="Semestre"
          rules={[
            {
              required: true,
              message: "Por favor informe o semestre!",
            },
          ]}
        >
          <Input
            required
            className="input"
            placeholder="Semestre"
            type="tel"
            //onInput={somenteNumeros}
            min="1"
            //onBlur={verificaVazio}
          />
        </Form.Item>
      </div>

      <div className="cardCampoRadio">
        <Row>
          <span style={{ color: "red" }}> *&nbsp;</span> <h3>Turno do Curso</h3>
        </Row>
        <div className="turnoCurso" style={{ display: "flex", justifyContent: "center" }}>
          <Form.Item name="turnoCurso">
            <Radio.Group onChange={onChage} value={value}>
              <Radio value={"MANHA"}>Manhã</Radio>
              <Radio value={"TARDE"}>Tarde</Radio>
              <Radio value={"NOITE"}>Noite</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
      </div>

      <div className="cardCampoRadio">
        <Row>
          <span style={{ color: "red" }}> *&nbsp;</span>{" "}
          <h3>Turno disponibilidade</h3>
        </Row>

        <div className="turnoCurso" style={{ display: "flex", justifyContent: "center" }}>
          <Form.Item name="turnoDisponibilidade">
            <Radio.Group onChange={onChageDisponivel} value={disponivel}>
              {value === "NOITE" ? <Radio value={"MANHA"}>Manhã</Radio> : ""}
              {value === "TARDE" ? <Radio value={"MANHA"}>Manhã</Radio> : ""}
              {value === "NOITE" ? <Radio value={"TARDE"}>Tarde</Radio> : ""}
              {value === "MANHA" ? <Radio value={"TARDE"}>Tarde</Radio> : ""}
            </Radio.Group>
          </Form.Item>
        </div>
      </div>

      <div className="cardCampoRadio">
        <Row>
          <span style={{ color: "red" }}>*&nbsp;</span>{" "}
          <h3> É portador de deficiência?</h3>
        </Row>

        <div className="turnoCurso" style={{ display: "flex", justifyContent: "center" }}>
          <Form.Item name="deficiente">
            <Radio.Group onChange={onChageDeficiencia} value={deficiencia}>
              <Radio value={true}>Sim</Radio>
              <Radio value={false}>Não</Radio>
            </Radio.Group>
          </Form.Item>
        </div>
      </div>

      <h3>Anexos necessários</h3>
      <br />

      <div className="duasCollumn">
        <div className="areaBtnAnexo">
          <Form.Item
            label="Declaração de matrícula"
            name="anexoDeclaracaoMatricula"
            rules={[{ required: true, message: "Por favor, informe o anexo" }]}
          >
            <Upload
              onRemove={() => updateFile({ anexoDeclaracaoMatricula: null })}
              {...props}
              beforeUpload={(info) =>
                beforeUpload(info, "anexoDeclaracaoMatricula")
              }
            >
              <Button className="btnAnexo" icon={<UploadOutlined />}>
                Anexo
              </Button>
            </Upload>
          </Form.Item>
          <Form.Item
            label="Histórico acadêmico"
            name="anexoHistoricoAcademico"
            rules={[{ required: true, message: "Por favor, informe o anexo" }]}
          >
            <Upload
              beforeUpload={(info) =>
                beforeUpload(info, "anexoHistoricoAcademico")
              }
              onRemove={() => updateFile({ anexoHistoricoAcademico: null })}
              {...props}
            >
              <Button className="btnAnexo" icon={<UploadOutlined />}>
                Anexo
              </Button>
            </Upload>
          </Form.Item>
        </div>
        <div className="areaBtnAnexo">
          <Form.Item
            label="Cópia RG (frente e verso)"
            name="anexoCopiaRG"
            rules={[{ required: true, message: "Por favor, informe o anexo" }]}
          >
            <Upload
              onRemove={() => updateFile({ anexoCopiaRG: null })}
              beforeUpload={(info) => beforeUpload(info, "anexoCopiaRG")}
              {...props}
            >
              <Button className="btnAnexo" icon={<UploadOutlined />}>
                Anexo
              </Button>
            </Upload>
          </Form.Item>

          <Form.Item
            label="Currículo"
            name="anexoCurriculo"
            rules={[{ required: true, message: "Por favor, informe o anexo" }]}
          >
            <Upload
              onRemove={() => updateFile({ anexoCurriculo: null })}
              beforeUpload={(info) => beforeUpload(info, "anexoCurriculo")}
              {...props}
            >
              <Button className="btnAnexo" icon={<UploadOutlined />}>
                Anexo
              </Button>
            </Upload>
          </Form.Item>
        </div>
      </div>
    </>
  );
}
